import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { FooterLinks } from '../../../constants/defaultTypes';
import './style.css';

const ComanyLinks = [
  {
    text: 'companyAbout',
    selfLink: '/about'
  },

  {
    text: 'companyBlog',
    link: FooterLinks.companyBlog
  },

  {
    text: 'companyCareers',
    link: FooterLinks.careers
  },

  {
    text: 'companyInternships',
    link: FooterLinks.internships
  },
  {
    text: 'Channel Partners',
    selfLink: '/channelPartners'
  },
  {
    text: 'Privacy Policy',
    selfLink: '/privacy_policy'
  }
];

const CourseLinks = [
  {
    text: 'courseML',
    selfLink: '/live_classes/ML'
  },

  {
    text: 'coursePy',
    selfLink: '/live_classes/PY'
  },

  {
    text: 'courseWeb',
    selfLink: '/live_classes/FSWD'
  },

  {
    text: 'courseReact',
    selfLink: '/live_classes/REACT'
  }
];

const SupportLinks = [
  {
    text: 'supportContact',
    selfLink: '/contact'
  },

  {
    text: 'supportServices',
    selfLink: '/live_classes'
  }
];

const BrandLinks = [
  {
    text: 'brandAB',
    link: FooterLinks.ab
  },

  {
    text: 'brandISB',
    link: FooterLinks.isb
  }
];

const FooterItem = ({ title, description, links = [] }) => {
  const { t } = useTranslation();
  return (
    <div className={`footer-item ${description ? 'footer-item-max' : ''}`}>
      <p className="footer-item-title">{t(title)}</p>
      {Boolean(description) && (
        <span className="footer-item-description">{t(description)}</span>
      )}
      {Boolean(links) &&
        Boolean(links.length) &&
        links.map(({ text, link, selfLink = '' }) => {
          return selfLink ? (
            <NavLink key={text} to={selfLink} className="footer-item-link">
              {t(text)}
            </NavLink>
          ) : (
            <a
              key={text}
              className="footer-item-link"
              target="_blank"
              href={link}>
              {t(text)}
            </a>
          );
        })}
    </div>
  );
};

const FooterIcon = ({ icon, link }) => {
  return (
    <a className="footer-icon-link" href={link} target="_blank">
      <i className={`fab fa-${icon}`}> </i>
    </a>
  );
};

const Footer = () => {
  return (
    <div className="footer-container">
      <div className="footer-content-row">
        <FooterItem title={'footerheading'} description={'footerpara'} />
        <FooterItem title={'footerCompany'} links={ComanyLinks} />
        <FooterItem title={'footerCourses'} links={CourseLinks} />
        <FooterItem title={'footerBrands'} links={BrandLinks} />
        <FooterItem title={'footerSupport'} links={SupportLinks} />
      </div>

      <div className="footer-social-row">
        <FooterIcon link={FooterLinks.facebook} icon="facebook-f" />
        <FooterIcon link={FooterLinks.youtube} icon="youtube" />
        <FooterIcon link={FooterLinks.linkedIn} icon="linkedin-in" />
      </div>
    </div>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/Components/Nav/Footer/index.js